import { borderRadius as designBorderRadius, spacing } from "../app/design-system";
import { sanitizeEmailHtml } from "../app/utils/sanitizeHtml";

/**
 * Anzeige eines E-Mail-Inhalts, wahlweise als bereinigtes HTML oder als Klartext.
 *
 * Der helle Rahmen ist bewusst fest und folgt nicht dem Theme: HTML-Mails sind für hellen
 * Hintergrund gestaltet und werden im dunklen Modus sonst unlesbar.
 */
export function EmailBodyView({ body, isHtml }: { body?: string | null; isHtml?: boolean | null }) {
  return (
    <div
      style={{
        border: "1px solid #f0f0f0",
        borderRadius: designBorderRadius.lg,
        padding: spacing.md,
        background: "#ffffff",
        color: "#000000",
        overflow: "auto"
      }}
    >
      {isHtml ? (
        <div dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(body) }} />
      ) : (
        <div style={{ whiteSpace: "pre-wrap" }}>{String(body || "")}</div>
      )}
    </div>
  );
}
